<template>
  <div>
    <filtro-buscar-itinerarios />
    <fieldset-component texto="Resultados de Búsqueda" class="mt-4" />
    <buscar-itinerarios-tabla :data="dataDatatable" />
  </div>
</template>

<script>

import { mapState, mapActions } from "vuex";

import FiltroBuscarItinerarios from "../../../components/filtros/lineas/FiltroBuscarItinerarios";
import BuscarItinerariosTabla from "../../../components/tablas/lineas/BuscarItinerariosTabla";

import FieldsetComponent from "../../../components/common/FieldsetComponent";

export default {
  components: {
    FiltroBuscarItinerarios,
    BuscarItinerariosTabla,
    FieldsetComponent,
  },
  data() {
    return {
      dataDatatable: [],
    };
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("lineas", ["dataDatatableListarBusquedaItinerariosFiltrada"]),
  },
  methods: {
    ...mapActions(["AccionCambiar", "ActionSetLoadingTable"]),
    ...mapActions("lineas", ["actionSetDataListarBusquedaItinerarios"]),

    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

  },
  created() {
    this.actualizarURL();
  },
  watch: {
    dataDatatableListarBusquedaItinerariosFiltrada: function (_new) {
      let me = this;
      if (_new) {
        me.dataDatatable = _new;
      }
    },
  },
};
</script>

<style></style>
